import React from "react";
import ChatWidgetConfig from "../../config/ChatWidgetConfig";
import "./styles.css";

const TextArea = ({
  value,
  placeholder = ChatWidgetConfig.inputPlaceholderText,
  onChange,
  onKeyDown,
}) => {
  return (
    <textarea
      type="text"
      placeholder={placeholder}
      className="text-box"
      rows="1"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={onKeyDown}
    />
  );
};

export default TextArea;
